<template>
	<span> {{ formated }} </span>
</template>

<script>
import moment from '@/packages/moment'
export default {
	name: 'TimeAgo',
	props: {
		timestamp: {
			type: Number,
			default: Date.now()
		}
	},
	data () {
		return {
			interval: null,
			formated: null
		}
	},
	created () {
		this.formated = moment(parseInt(this.timestamp)).fromNow()
		this.interval = setInterval(() => {
			this.formated = moment(parseInt(this.timestamp)).fromNow()
		}, 60 * 1000)
	},
	beforeDestroy () {
		clearInterval(this.interval)
	}
}
</script>
